import { EChartsInstance } from 'echarts-for-react';
import once from 'lodash/once';

const importJsPDF = once(() => import('jspdf'));

export const saveChartAsPdf = async (chartInstance: EChartsInstance, name: string) => {
  if (!chartInstance) return;

  const { jsPDF } = await importJsPDF();
  const height = chartInstance.getHeight();
  const width = chartInstance.getWidth();
  const imgData = chartInstance.getDataURL();
  const doc = new jsPDF('l', 'px', [height, width]);

  doc.addImage(imgData, 'PNG', -5, 10, width, height);
  doc.save(name);
};
